import React, { lazy, Suspense, useEffect, type ReactElement } from 'react'

import { Loader } from '../components/Loader'
import { getAccessToken } from '../services/authentication'
import { environmentVariables } from '../utils/environmentVariables'
import { redirectToUrl } from '../utils/location'

const LazyChangePasswordPage = lazy(() =>
  import('../pages/ChangePassword').then((module) => ({ default: module.ChangePasswordPage })),
)

export const ChangePasswordRoute = (): ReactElement => {
  useEffect(() => {
    if (!getAccessToken()) {
      redirectToUrl(`${environmentVariables('AUTH_API_URL')}/signin`)
    }
  }, [])

  if (!getAccessToken()) {
    return <Loader />
  }

  return (
    <Suspense fallback={<Loader />}>
      <LazyChangePasswordPage />
    </Suspense>
  )
}
